// src/components/common/MaintenanceGate.jsx
import React, { useState, useEffect } from 'react';
import MaintenancePage from './MaintenancePage';

const MaintenanceGate = ({ children }) => {
  const [maintenanceOn, setMaintenanceOn] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    checkMaintenance();
  }, []);

  const checkMaintenance = async () => {
    try {
      const res = await fetch(`https://demo-site.creativepulse.pk/demo-api/public/get-settings.php?t=${Date.now()}`, { cache: 'no-store' });
      const data = await res.json();
      if (data.success) {
        setMaintenanceOn(data.settings.maintenance_mode_enabled === '1');
      }
    } catch (e) {
      console.error('Error checking maintenance status:', e);
    } finally {
      setChecked(true);
    }
  };

  const isAdminRoute = window.location.pathname.startsWith('/admin');

  // Real bypass: only an actually logged-in admin sees the live site while
  // paused — matches the same localStorage check AdminPanel.jsx already
  // uses for its own auth. Not just "any /admin URL" anymore.
  const isLoggedInAdmin = !!localStorage.getItem('adminToken');

  if (!checked) return null;
  if (maintenanceOn && !isAdminRoute && !isLoggedInAdmin) return <MaintenancePage />;

  return children;
};

export default MaintenanceGate;